var map = {
	"./de/routes.json": 5412,
	"./en/routes.json": 9288,
	"./es/routes.json": 1409,
	"./fr/routes.json": 8329,
	"./hu/routes.json": 224,
	"./it/routes.json": 5801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;